import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";

const PressContext = React.createContext({
  state: { pressList: {}, press: {} },
  actions: {
    getPress: () => {},
    getPressList: () => {},
  },
});

const PressProvider = ({ children }) => {
  const [press, setPress] = useState({});
  const [pressList, setPressList] = useState([]);
  
  const getPressList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/admin/media/list", 
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        mediaInfoTitle: pageInfo && pageInfo.mediaInfoTitle,
      }
    }).then((res) => {
      if (res.code === 200) {
        setPressList(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getPress = useCallback((pressId) => {
    HttpAction({
      url:"api/admin/media", 
      method: "get",
      params: {
        mediaInfoId: pressId
      }
    }).then((res) => {
      if (res.code === 200) {
        setPress(res.data); 
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createPress = useCallback(async (pressData,setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/media/save`, pressData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updatePress = useCallback(async(pressData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/media/modify`, pressData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
    
  }, []);

  const deletePress = useCallback((pressId, history, url) => {
    HttpAction({
      url: "api/admin/media",
      method: "delete",
      params: {
        mediaInfoId: pressId
      }
    }).then((res) => {
      if (res.code === 200) {
      history.push(url)
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { press, pressList },
    actions: { getPressList, getPress, createPress, updatePress, deletePress },
  };

  return (
    <PressContext.Provider value={value}>
      {children}
    </PressContext.Provider>
  );
};

const { Consumer: PressConsumer } = PressContext;

export { PressProvider, PressConsumer, PressContext };

export default PressContext;
